<template>
  <span class="ai-token-text">
    <template v-for="(part, i) in segments">
      <span
        v-if="part.type === 'text'"
        :key="'t-' + i"
      >{{ part.value }}</span>
      <span
        v-else
        :key="'k-' + i"
        class="ai-token-chip"
        :class="{ 'ai-token-chip--value': part.filled }"
        :title="part.title"
      >{{ part.label }}</span>
    </template>
  </span>
</template>

<script>
const TOKEN_RE = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}|\{([a-zA-Z0-9_]+)\}/g

const TOKEN_LABELS = {
  agent_name: 'Agent',
  company: 'Company',
  client: 'Client',
  role: 'Role',
  job_title: 'Job title',
  industry: 'Industry',
  location: 'Location',
  job_type: 'Job type',
  work_summary: 'Work',
  preferred_qualification: 'Qualification',
  min_experience_years: 'Min exp',
  max_experience_years: 'Max exp',
  min_ctc: 'Min CTC',
  max_ctc: 'Max CTC',
  ctc: 'CTC',
  client_name: 'Client',
  experience: 'Experience',
  requirements: 'Requirements',
  mandatory_skill: 'Skill',
  equipment_examples: 'Equipment',
  candidate_name: 'Candidate',
  drive_name: 'Drive',
  drive_dates: 'Dates',
  drive_location: 'Venue',
}

function friendlyTokenLabel(key) {
  if (TOKEN_LABELS[key]) return TOKEN_LABELS[key]
  return String(key || '').replace(/_/g, ' ')
}

export default {
  name: 'AiCallingTokenText',
  props: {
    text: { type: String, default: '' },
    values: { type: Object, default: () => ({}) },
    resolve: { type: Boolean, default: false },
  },
  computed: {
    segments() {
      const src = String(this.text || '')
      const values = this.values || {}
      const parts = []
      let last = 0
      TOKEN_RE.lastIndex = 0
      let match = TOKEN_RE.exec(src)
      while (match) {
        if (match.index > last) {
          parts.push({ type: 'text', value: src.slice(last, match.index) })
        }
        const key = match[1] || match[2]
        const resolved = values[key] != null ? String(values[key]).trim() : ''
        const filled = this.resolve && !!resolved
        parts.push({
          type: 'token',
          key,
          label: filled ? resolved : friendlyTokenLabel(key),
          filled,
          title: filled
            ? `${friendlyTokenLabel(key)}: ${resolved}`
            : `{{${key}}}`,
        })
        last = match.index + match[0].length
        match = TOKEN_RE.exec(src)
      }
      if (last < src.length) {
        parts.push({ type: 'text', value: src.slice(last) })
      }
      if (!parts.length) {
        parts.push({ type: 'text', value: src })
      }
      return parts
    },
  },
}
</script>

<style scoped>
.ai-token-text {
  display: inline;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.ai-token-chip {
  display: inline;
  align-items: center;
  max-width: 100%;
  margin: 0 0.1em;
  padding: 0 0.4em;
  border-radius: 999px;
  background: rgba(0, 172, 153, 0.12);
  border: 1px solid rgba(0, 172, 153, 0.35);
  color: #007a6e;
  font-size: 0.8125em;
  font-weight: 700;
  line-height: 1.45;
  vertical-align: baseline;
  white-space: normal;
}
.ai-token-chip--value {
  background: rgba(0, 172, 153, 0.16);
  border-color: rgba(0, 172, 153, 0.45);
  font-weight: 700;
}
</style>
